import { DateTime } from "luxon";
import { types } from "mobx-state-tree";
const formEntry = types.model({
    values: types.frozen(),
    createdAt: types.Date,
});
export const formStore = types
    .model({
    autoSaves: types.map(formEntry),
})
    .actions((self) => {
    return {
        expireEntries: (maxAge) => {
            const expireTime = DateTime.now().minus(maxAge);
            const entries = self.autoSaves;
            entries.forEach((entry, key) => {
                if (entry.createdAt < expireTime.toJSDate()) {
                    self.autoSaves.delete(String(key));
                }
            });
        },
        addEntry: (id, values) => {
            self.autoSaves.set(id, {
                values,
                createdAt: new Date(),
            });
        },
        updateEntry: (id, values) => {
            self.autoSaves.set(id, {
                values,
                createdAt: new Date(),
            });
        },
        removeEntry: (id) => {
            self.autoSaves.delete(id);
        },
        getValues: (id) => {
            return self.autoSaves.get(id)?.values;
        },
        getEntries: () => {
            return Array.from(self.autoSaves.entries());
        },
    };
})
    .create({
    autoSaves: {},
});
//# sourceMappingURL=data:application/json;base64,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